import { useEffect, useState } from 'react';
import { FilterInput, RowFiltering, AutoTooltip } from '@refinitiv-ui/efx-grid/extensions';
import { fetchData, styles2, styles } from './Helpers';

export default function NewsLicensePli({tab}) {
  const [fullData, setFullData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const headers = {
      "News_Reuters_News": "Equity & Markets News",
      "News_3rd_Party_News": "Third Party News Sources",
      "News_Top_News": "Top News",
      "News_Online_Reports": "Online Reports",
      "News_Breakingviews": "BreakingViews",
      "News_Significant_Development": "Significant Development",
      "News_Japanese_Investor_Brief": "Investors Brief - Japanese Language"
    }
    fetchData("News_License_PLI").then((res) => {
      setFullData(res.filter(item => item.package === headers[tab]));
      if(tab === "News_Reuters_News"){
        setFullData(prev => [...prev, ...res.filter(item => item.package === "Global Financial Markets News")]);
      } 
      setLoading(false);
    });
  }, [tab]);

  useEffect(() => {
    const grid = document.getElementById("pliGrid");
    const filterInputExt = new FilterInput();
    const rowFilteringExt = new RowFiltering();
    const autoToolTipExt = new AutoTooltip();
    const columns = [
      { name: 'Use Case', field: 'useCase', leftPinned: true, scalable: true, styles: styles2 },
      { name: 'Package', field: 'package', scalable: true,styles: styles },
      { name: 'Region', field: 'region', scalable: true},
      { name: 'Sub Topic', field: 'subTopic', scalable: true,styles: styles },
      { name: 'PLI Code', field: 'pliCode', scalable: true},
      { name: 'Language', field: 'language', scalable: true,styles: styles },
      { name: 'Delivery', field: 'delivery', scalable: true},
      { name: 'PLI Description', field: 'pliDescription', scalable: true, styles: styles }
    ];

    function gridConfigured(e) {
      const core = e.detail.api.getCoreGrid();
      core.setColumnWidths([200, 250, 200, 350, 120, 150, 350, 400], false);
    }

    grid.config = {
      rowHeight: 60,
      headerRowHeight: 60,
      autoHideScrollbar: false,
      columns: columns,
      dataModel: {
        data: fullData
      },
      sorting: {
        sortableColumns: false,
        initialSort: {
            colIndex: 0, // Column index
            sortOrder: "a"
        }
      },
      rowFiltering: {
        disabledUI: true
      },
      autoTooltip: {
        title: true
      },
      extensions: [
        rowFilteringExt,
        filterInputExt,
        autoToolTipExt
      ]
    };
    grid.addEventListener('configured', gridConfigured);
  }, [fullData]);

  return (
    <div className="main-div inner-main-div">
      <ef-loader class="loader" hidden={!loading}></ef-loader>
      <h4>News License PLI</h4>
      <ef-layout>
        <efx-grid id="pliGrid" className="entity-grid"></efx-grid>
      </ef-layout>
    </div>
  );
}